import { useState } from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';
import { Clusterer } from '@react-google-maps/marker-clusterer';

export interface MapMarkerProps {
	children?: React.ReactElement;
	clusterer?: Clusterer;
	content: {
		properties: {
			title: string;
			text?: string;
			latitude: number;
			longitude: number;
		};
	};
}

export const MapMarker: React.FC<MapMarkerProps> = (props) => {
	const [selected, setSelected] = useState(false);

	const position = {
		lat: props.content.properties.latitude,
		lng: props.content.properties.longitude,
	};

	return (
		<Marker position={position} onClick={() => setSelected(true)} clusterer={props.clusterer} title={props.content.properties.title}>
			{props.children && selected && (
				<InfoWindow position={position} onCloseClick={() => setSelected(false)}>
					{props.children}
				</InfoWindow>
			)}
		</Marker>
	);
};
